import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { ExportAllActiveProjectPlansCommandV1 } from '@Quest/Portfolios/Domain/commands-core';
import PortfoliosCommands from '@Quest/Portfolios/Domain/commands-vue-component';
import PortfoliosQueries from '@Quest/Portfolios/Domain/queries-vue-component';
import { PortfolioPlanningModuleStatusReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { PortfolioNavigation } })
export default class PortfolioPlanningEntrancePage extends mixins(PortfoliosQueries, PortfoliosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: PortfolioPlanningModuleStatusReadModel | null = null;

    handleExportAllActiveProjectPlansCommand()
    {
        this.invokeExportAllActiveProjectPlansCommandV1(this.workspaceId, this.rm!.PortfolioId);
    }

    mounted()
    {
        document.title = "Portfolio planning | TransparentChoice";
        this.runPortfolioPlanningModuleStatusQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PortfolioPlanningModuleStatusReadModel")
        {
            this.rm = model as PortfolioPlanningModuleStatusReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (ExportAllActiveProjectPlansCommandV1.matchType(cmd)) 
        {
            if (result) 
            {
                location.href = result;
            }
        }
    }
}